package ui.campaign.detailv2.editor.page

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import tools.GlobalObjectShare
import tools.rememberScrollState
import tools.storeScrollState
import ui.campaign.detailv2.editor.CampaignEditorScope
import ui.campaign.detailv2.editor.CampaignEditorVM
import ui.campaign.detailv2.editor.NextButton
import ui.campaign.detailv2.editor.widget.DialogVisualDurationValidation
import ui.campaign.detailv2.editor.widget.ListingEntryVisualItem
import ui.campaign.detailv2.editor.wrapper.CampaignWrapperE
import ui.campaign.detailv2.editor.wrapper.ImplCampaignWrapperEVisual
import ui.snackBarStateGlobal
import ui.widget.DialogState
import ui.widget.blockTouch

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun CampaignEditorScope.CampaignPage02Visual(nnvl: CampaignWrapperE) {

    val scope = rememberCoroutineScope()

    var showOverlayLoader by remember {
        mutableStateOf(false)
    }

    GlobalObjectShare.Consumer(*nnvl.visual.adapterVisuals.state.map { it.pickerKey }.toTypedArray())

    val scrollState = nav.rememberScrollState("visuals", false)

    val validationDialogState = DialogState.remember(false, "visualValidator")

    fun openResourcePicker(item: ImplCampaignWrapperEVisual.AdapterVisual.Item) {
        GlobalObjectShare.launchImagePicker(
            key = item.pickerKey,
            nav = nav,
            args = item.pickerArgs
        ) {
            it.firstOrNull()?.apply {
                val entry = item.createVisualEntry(this)
                if (item.isVisualDurationOk(this)) item.set(entry)
                else nnvl.visual.combinationToCheck = item to entry
            }
        }
    }

    LaunchedEffect(nnvl.visual.combinationToCheck) {
        if (nnvl.visual.combinationToCheck != null) {
            validationDialogState.show()
        }
    }

    DialogVisualDurationValidation(
        state = validationDialogState,
        nnvl = nnvl,
        wrapper = nnvl.visual,
        canChangeSettings = true,
        onPickDifferent = { item ->
            validationDialogState.hide()
            openResourcePicker(item)
        },
        onOpenGeneralSettings = { item, resource ->
            item.set(resource)
            validationDialogState.hide()
            action(CampaignEditorVM.Action.PageExact(0))
        },
        onDurationChange = { item, resource, newDuration ->
            item.set(resource)
            nnvl.general.impressionDuration.set(TextFieldValue(newDuration.inWholeSeconds.toString()))
            validationDialogState.hide()
            action(CampaignEditorVM.Action.PageExact(0))
        },
        onIncreaseDuration = { item, resource, duration ->
            showOverlayLoader = true
            scope.launch {
                runCatching {
                    item.set(vm.resizeDuration(resource, duration))
                }.onFailure {
                    launch {
                        snackBarStateGlobal.showSnackbar(it.message!!)
                    }
                }
                showOverlayLoader = false
            }
            validationDialogState.hide()
        },
        onReduceDuration = { item, resource, duration ->
            showOverlayLoader = true
            scope.launch {
                runCatching {
                    item.set(vm.resizeDuration(resource, duration))
                }.onFailure {
                    launch {
                        snackBarStateGlobal.showSnackbar(it.message!!)
                    }
                }
                showOverlayLoader = false
            }
            validationDialogState.hide()
        })


    Box(Modifier.fillMaxSize()) {
        FlowRow(
            Modifier.fillMaxWidth()
                .wrapContentHeight(Alignment.Top)
                .verticalScroll(scrollState)
                .padding(16.dp),
            horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.CenterHorizontally),
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            nnvl.visual.adapterVisuals.state
                .filter { it.data.mask in nnvl.visual.deviceRatioMasks }
                .sortedWith(compareBy({ !it.data.land }, { Int.MAX_VALUE - it.data.mask }))
                .forEach {
                    ListingEntryVisualItem(
                        item = it,
                        openIssueResolver = {
                            nnvl.visual.combinationToCheck = it to it.resource!!
                        },
                        openResourcePicker = {
                            nav.storeScrollState("visuals")
                            openResourcePicker(it)
                        })
                }
            Box(Modifier.fillMaxWidth()) {
                NextButton(
                    skipToSummary =
                        (nnvl.offsets.adapter.state.isEmpty() || nnvl.offsets.adapter.state.all { item -> !item.excluded.state }) &&
                                nnvl.visualDynamic.adapterGroups.state.isEmpty() &&
                                nnvl.apps.adapterApps.state.isEmpty()
                )
            }
        }

        AnimatedVisibility(
            visible = showOverlayLoader,
            modifier = Modifier.fillMaxSize(),
            enter = fadeIn(),
            exit = fadeOut()
        ) {
            Box(
                Modifier.fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.7F))
                    .blockTouch()
            ) {
                CircularProgressIndicator(Modifier.align(Alignment.Center))
            }
        }
    }

}

